import { Link } from "react-router-dom";
import { getAllNews, formatNewsDate } from "../lib/news";
import { Card } from "../components/ui/Card";
import { useSeoMeta, SITE_URL, SITE_NAME, PUBLISHER_NAME } from "../lib/seo";

const DESCRIPTION =
  "Measured coverage of real Bitcoin and crypto security incidents, exchange hacks, scam patterns, and network developments — sourced and linked, never speculation or price predictions.";

export default function NewsIndex() {
  const posts = getAllNews();

  useSeoMeta({
    title: "News",
    description: DESCRIPTION,
    path: "/news",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: `${SITE_NAME} News`,
      description: DESCRIPTION,
      url: `${SITE_URL}/news`,
      publisher: { "@type": "Organization", name: PUBLISHER_NAME, url: SITE_URL },
      hasPart: posts.map((post) => ({
        "@type": "NewsArticle",
        headline: post.title,
        url: `${SITE_URL}/news/${post.slug}`,
        datePublished: post.date,
      })),
    },
  });

  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="font-display text-3xl mb-2">News</h1>
      <p className="text-muted mb-10">{DESCRIPTION}</p>

      {posts.length === 0 && <p className="text-muted text-sm">No news posts yet — check back soon.</p>}

      <div className="grid gap-4">
        {posts.map((post) => (
          <Card key={post.slug} as={Link} to={`/news/${post.slug}`} padding="lg" interactive className="block">
            <p className="text-xs text-muted font-mono">{formatNewsDate(post.date)}</p>
            <h2 className="mt-1 font-display text-xl">{post.title}</h2>
            <p className="mt-2 text-sm text-muted">{post.description}</p>
            <span className="mt-3 inline-block text-sm text-ledger-400">Read more →</span>
          </Card>
        ))}
      </div>
    </div>
  );
}
